var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputerBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 3a4 4 0 0 1 4 4v13a4 4 0 0 1-4 4h-4.001l.001.343a3 3 0 0 0 .7 1.927l.18.195.827.828c.63.63.184 1.707-.707 1.707H10c-.89 0-1.337-1.077-.707-1.707l.828-.828A3 3 0 0 0 11 24.343V24H7a4 4 0 0 1-3.993-3.765L3 20V7l.007-.235A4 4 0 0 1 7 3h18zm-6 21h-6.001l.001.343a5 5 0 0 1-.72 2.584l-.048.073h7.535l-.048-.073a5 5 0 0 1-.71-2.28L19 24.344V24zm8-4.537-.045.028A3.982 3.982 0 0 1 25 20H7c-.71 0-1.377-.185-1.955-.51L5 19.464V20a2 2 0 0 0 1.807 1.99L7 22h18a2 2 0 0 0 2-2v-.537zM25 5H7a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V7l-.01-.193A2 2 0 0 0 25 5z",
    fill: "#192340",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerBlack);
export default __webpack_public_path__ + "static/media/computer-black.e9ceee63d115b4ed0afe24a9a1316025.svg";
export { ForwardRef as ReactComponent };